import React from 'react';
import { LoginForm } from '../components/LoginForm';
import { RightDesignPanel } from '../components/RightDesignPanel';
import { useLoginForm } from '../hooks/useLoginForm';

export const LoginPage = () => {
  const formProps = useLoginForm();

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4 sm:p-6 lg:p-8 relative overflow-hidden" 
      style={{ 
        fontFamily: "'Montserrat', sans-serif",
        backgroundImage: "url('/login-bg.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }}
    >
      {/* Contained sharp luxury modular card - split screen layout */}
      <div className="w-full max-w-5xl bg-white rounded-2xl overflow-hidden shadow-[0_24px_80px_rgba(162,115,39,0.08)] border border-slate-200/60 flex flex-col lg:flex-row min-h-[640px] relative z-10">
        <LoginForm {...formProps} />
        <RightDesignPanel />
      </div>
    </div>
  );
};




